var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('section',{staticClass:"container"},[_c('Header'),_c('Hero'),_c('Bio')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }